import React from "react";
import { Calendar, MapPin } from "lucide-react";

const HIGHLIGHTS = [
  {
    date: "06.06.2026",
    day: "06",
    month: "Juni",
    weekday: "Sa",
    event: "Schützenfest",
    location: "Wedau",
    badge: null,
  },
  {
    date: "18.07.2026",
    day: "18",
    month: "Juli",
    weekday: "Sa",
    event: "Stadtfest",
    location: "Duisburg",
    badge: null,
  },
  {
    date: "01.08.2026",
    day: "01",
    month: "August",
    weekday: "Sa",
    event: "Sommerfest · Merkur Spielbank",
    location: "Duisburg",
    badge: null,
  },
  {
    date: "29.08.2026",
    day: "29",
    month: "August",
    weekday: "Sa",
    event: "Bärenfest",
    location: "Oberhausen",
    badge: "Open Air",
  },
  {
    date: "25.09.2026",
    day: "25",
    month: "September",
    weekday: "Fr",
    event: "Schlagerwelle",
    location: "Düsseldorf",
    badge: null,
  },
  {
    date: "29.09.2026",
    day: "29",
    month: "September",
    weekday: "Di",
    event: "Cannstatter Wasen",
    location: "Stuttgart",
    badge: "Volksfest",
  },
  {
    date: "02.10.2026",
    day: "02",
    month: "Oktober",
    weekday: "Fr",
    event: "Malle-Party",
    location: "Olfen",
    badge: null,
  },
];

export default function TourHighlights() {
  return (
    <section
      id="buehnen"
      data-testid="tour-highlights-section"
      className="relative bg-[#0F0F0F] py-24 md:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Left – pitch */}
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <p className="overline" data-testid="tour-overline">
              <span className="gold-rule mr-4 align-middle" />
              Live · Highlights 2026
            </p>
            <h2
              className="font-display mt-4 text-white leading-[1.05] tracking-tight"
              style={{ fontSize: "clamp(2.4rem, 5vw, 4rem)", fontWeight: 600 }}
              data-testid="tour-headline"
            >
              Auf der
              <br />
              <span className="italic text-[#D4AF37]">Bühne.</span>
              <br />
              2026.
            </h2>
            <p className="mt-8 text-[#C9C9C9] font-body text-base md:text-lg leading-relaxed max-w-md">
              Eine Auswahl bestätigter Auftritte 2026 — von Volksfesten und
              Schützenfesten über Stadtfeste bis zum legendären
              Cannstatter Wasen. Weitere Termine auf Anfrage.
            </p>

            <a
              href="#booking"
              data-testid="tour-cta"
              className="btn-secondary mt-10"
            >
              Termin anfragen
            </a>
          </div>

          {/* Right – list */}
          <div className="lg:col-span-7" data-testid="tour-list">
            <ul className="divide-y divide-white/5 border-y border-white/5">
              {HIGHLIGHTS.map((h, idx) => (
                <li
                  key={h.date}
                  data-testid={`tour-entry-${h.date}`}
                  className="grid grid-cols-12 gap-4 py-7 md:py-8 group hover:bg-white/[0.015] transition-colors duration-300 px-2"
                >
                  {/* Day column */}
                  <div className="col-span-3 md:col-span-2 flex flex-col">
                    <span className="font-display text-3xl md:text-5xl text-[#D4AF37] leading-none">
                      {h.day}
                    </span>
                    <span className="mt-1 text-[10px] tracking-[0.22em] uppercase text-[#A3A3A3]">
                      {h.weekday} · {h.month}
                    </span>
                  </div>

                  {/* Event column */}
                  <div className="col-span-7 md:col-span-8 flex flex-col justify-center">
                    <h3 className="font-display text-lg md:text-2xl text-white leading-tight group-hover:text-[#F3E5AB] transition-colors">
                      {h.event}
                    </h3>
                    <div className="mt-2 flex items-center gap-2 text-[#A3A3A3] text-sm">
                      <MapPin size={12} strokeWidth={1.5} className="text-[#D4AF37]" />
                      <span>{h.location}</span>
                    </div>
                  </div>

                  {/* Badge / year */}
                  <div className="col-span-2 md:col-span-2 flex items-start justify-end">
                    {h.badge ? (
                      <span className="px-2.5 py-1 border border-[#D4AF37]/40 text-[10px] tracking-[0.22em] uppercase text-[#D4AF37] whitespace-nowrap">
                        {h.badge}
                      </span>
                    ) : (
                      <span className="hidden md:inline-block text-[10px] tracking-[0.22em] uppercase text-[#7A7A7A]">
                        2026
                      </span>
                    )}
                  </div>

                  {/* Index marker — leftmost */}
                  <span className="hidden md:block absolute font-display text-[#D4AF37]/20 text-xs tracking-[0.3em] uppercase">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </li>
              ))}
            </ul>

            <div
              className="mt-10 flex items-center gap-3 text-xs tracking-[0.22em] uppercase text-[#7A7A7A]"
              data-testid="tour-disclaimer"
            >
              <Calendar size={12} strokeWidth={1.5} className="text-[#D4AF37]" />
              Stand: Dezember 2025 · Weitere Daten auf Anfrage
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
